import { all, put, takeLatest } from 'redux-saga/effects';
import {
  getBlockedEnvironmentsRequest,
  getBlockedEnvironmentsFulfilled,
  getBlockedEnvironmentsRejected,
  getEnvironmentHealthRequest,
  getEnvironmentHealthFulfilled,
  getEnvironmentHealthRejected,
  getInstanceStatusFulfilled,
  getInstanceStatusRejected,
  getInstanceStatusRequest,
  getEnvironmentAndCeleryQueueStatusRequest,
  getEnvironmentAndCeleryQueueStatusFulfilled,
  getEnvironmentAndCeleryQueueStatusRejected,
  getSessionsHistoryMonitorGraphFulfilled,
  getSessionsHistoryMonitorGraphRejected,
  getSessionsHistoryMonitorGraphRequest,
  getClientsHistoryMonitorGraphFulfilled,
  getClientsHistoryMonitorGraphRejected,
  getClientsHistoryMonitorGraphRequest,
  getUsersHistoryMonitorGraphFulfilled,
  getUsersHistoryMonitorGraphRejected,
  getUsersHistoryMonitorGraphRequest,
  getEnvironmentsCostMonitorGraphRequest,
  getEnvironmentsCostMonitorGraphFulfilled,
  getEnvironmentsCostMonitorGraphRejected,
  getFlavorsCostFulfilled,
  getFlavorsCostRejected,
  getFlavorsCostRequest,
  getFlavorEnvironmentsFulfilled,
  getFlavorEnvironmentsRejected,
  getFlavorEnvironmentsRequest,
  getInstancesWithSessionTimeoutRequest,
  getInstancesWithSessionTimeoutFulfilled,
  getInstancesWithSessionTimeoutRejected,
  getEnvironmentsWithFailedZeroTrustRequest,
  getEnvironmentsWithFailedZeroTrustFulfilled,
  getEnvironmentsWithFailedZeroTrustRejected,
  getMonthlyEnvironmentsCostMonitorGraphFulfilled,
  getMonthlyEnvironmentsCostMonitorGraphRejected,
  getMonthlyEnvironmentsCostMonitorGraphRequest,
} from './actions';
import endpoints, { api } from './endpoints';

function* getBlockedEnvironmentsRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getBlockedEnvironmentsData(payload),
    });
    return yield put(getBlockedEnvironmentsFulfilled(data));
  } catch (error) {
    return yield put(getBlockedEnvironmentsRejected());
  }
}

function* getEnvironmentHealthRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentHealthData(payload),
    });

    const {
      data: { count },
    } = yield api.get({
      url: endpoints.getEnvironmentHealthData({
        ...payload,
      }),
    });

    return yield put(
      getEnvironmentHealthFulfilled({
        ...data,
        environmentToAnalyzeCount: count,
      })
    );
  } catch (error) {
    return yield put(getEnvironmentHealthRejected());
  }
}

function* getInstanceStatusRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getInstanceStatusData(payload),
    });

    return yield put(getInstanceStatusFulfilled(data));
  } catch (error) {
    return yield put(getInstanceStatusRejected());
  }
}

function* getEnvironmentAndCeleryQueueStatusRequestSaga() {
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentAndCeleryQueueStatus(),
    });

    return yield put(getEnvironmentAndCeleryQueueStatusFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentAndCeleryQueueStatusRejected());
  }
}

function* getSessionsHistoryMonitorGraphRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getSessionsHistoryMonitorGraph(
        payload.intervalTime,
        payload.start_date,
        payload.end_date
      ),
    });

    return yield put(getSessionsHistoryMonitorGraphFulfilled(data));
  } catch (error) {
    return yield put(getSessionsHistoryMonitorGraphRejected());
  }
}

function* getClientsHistoryMonitorGraphRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getClientsHistoryMonitorGraph(payload.intervalTime),
    });

    return yield put(getClientsHistoryMonitorGraphFulfilled(data));
  } catch (error) {
    return yield put(getClientsHistoryMonitorGraphRejected());
  }
}

function* getUsersHistoryMonitorGraphRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getUsersHistoryMonitorGraph(payload.intervalTime),
    });

    return yield put(getUsersHistoryMonitorGraphFulfilled(data));
  } catch (error) {
    return yield put(getUsersHistoryMonitorGraphRejected());
  }
}

function* getEnvironmentsCostMonitorGraphRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentsCostMonitorGraph(payload.intervalTime),
    });

    return yield put(getEnvironmentsCostMonitorGraphFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentsCostMonitorGraphRejected());
  }
}

function* getMonthlyEnvironmentsCostMonitorGraphRequestSaga() {
  try {
    const { data } = yield api.get({
      url: endpoints.getMonthlyEnvironmentsCostMonitorGraph(),
    });

    return yield put(getMonthlyEnvironmentsCostMonitorGraphFulfilled(data));
  } catch (error) {
    return yield put(getMonthlyEnvironmentsCostMonitorGraphRejected());
  }
}

function* getFlavorsCostMonitorRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getFlavorsCost(payload),
    });
    return yield put(getFlavorsCostFulfilled(data));
  } catch (error) {
    return yield put(getFlavorsCostRejected());
  }
}

function* getFlavorEnvironmentsRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getFlavorEnvironments(payload),
    });

    return yield put(getFlavorEnvironmentsFulfilled(data));
  } catch (error) {
    return yield put(getFlavorEnvironmentsRejected());
  }
}

function* getInstancesWithSessionTimeoutRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getInstancesWithSessionTimeout(payload),
    });

    return yield put(getInstancesWithSessionTimeoutFulfilled(data));
  } catch (error) {
    return yield put(getInstancesWithSessionTimeoutRejected());
  }
}

function* getEnvironmentsWithFailedZeroTrustRequestSaga({ payload }) {
  const { query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentsWithFailedZeroTrust(query),
    });

    return yield put(getEnvironmentsWithFailedZeroTrustFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentsWithFailedZeroTrustRejected());
  }
}

export default all([
  takeLatest(getBlockedEnvironmentsRequest, getBlockedEnvironmentsRequestSaga),
  takeLatest(getEnvironmentHealthRequest, getEnvironmentHealthRequestSaga),
  takeLatest(getInstanceStatusRequest, getInstanceStatusRequestSaga),
  takeLatest(
    getEnvironmentAndCeleryQueueStatusRequest,
    getEnvironmentAndCeleryQueueStatusRequestSaga
  ),
  takeLatest(
    getEnvironmentsWithFailedZeroTrustRequest,
    getEnvironmentsWithFailedZeroTrustRequestSaga
  ),
  takeLatest(
    getSessionsHistoryMonitorGraphRequest,
    getSessionsHistoryMonitorGraphRequestSaga
  ),
  takeLatest(
    getClientsHistoryMonitorGraphRequest,
    getClientsHistoryMonitorGraphRequestSaga
  ),
  takeLatest(
    getUsersHistoryMonitorGraphRequest,
    getUsersHistoryMonitorGraphRequestSaga
  ),
  takeLatest(
    getEnvironmentsCostMonitorGraphRequest,
    getEnvironmentsCostMonitorGraphRequestSaga
  ),
  takeLatest(
    getMonthlyEnvironmentsCostMonitorGraphRequest,
    getMonthlyEnvironmentsCostMonitorGraphRequestSaga
  ),
  takeLatest(getFlavorsCostRequest, getFlavorsCostMonitorRequestSaga),
  takeLatest(getFlavorEnvironmentsRequest, getFlavorEnvironmentsRequestSaga),
  takeLatest(
    getInstancesWithSessionTimeoutRequest,
    getInstancesWithSessionTimeoutRequestSaga
  ),
]);
